import request from '../../axios/axiosconfig.js'

export function getDevice(param) {
  return request({
    url: '/ps/deviceManagement/getDevice',
    method: 'get',
    params: param,
    timeout: 20000
  })
}

export function pop(param) {
  return request({
    url: '/ps/deviceManagement/pop',
    method: 'post',
    params: param
  })
}

export function restart(param) {
  return request({
    url: '/ps/deviceManagement/restart',
    method: 'get',
    params: param
  })
}

export function allEject(popDeviceDtoList) {
  alert(JSON.stringify(popDeviceDtoList))
  return request({
    url: '/ps/deviceManagement/allEject',
    method: 'post',
    params: popDeviceDtoList,
    headers: {'Content-Type': 'application/json'}
  })
}

export function outWarehouse(jsonObject) {
  return request({
    url: '/ps/inWarehouse/outWarehouse',
    method: 'post',
    params: jsonObject,
    headers: {'Content-Type': 'application/json'}
  })
}




// WEBPACK FOOTER //
// ./src/api/devicemanagement/device.js